import { render, staticRenderFns } from "./SoPopup2.vue?vue&type=template&id=03fc5a2a"
import script from "./SoPopup2.vue?vue&type=script&lang=js"
export * from "./SoPopup2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports